module.exports = __webpack_public_path__ + "img/mlcisocert_52022KV.3d9a5c59.jpg";